import React from "react";
import TextInput from "../../../core/form/TextInput";

let ClientFullnameField = (props) => {

    return <TextInput
        name='fullname'
        label='form.client.fullname'
        required={true}
        {...props}
    />

}

export default ClientFullnameField